<template>
    <div>
        <div class="btn-group" v-if="options.length > 1">
            <div class="btn-group">
                <button class="btn dropdown-toggle" type="button" :id="'dropdownfilter'+$parent._uid+(keyName || keyFunc)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <slot></slot> <small :class="{'fas fa-filter glyphicon glyphicon-filter': true, 'text-success': selected.length}"></small>
                </button>
                <div class="dropdown-menu dropdown-filter" :aria-labelledby="'dropdownfilter' + $parent._uid + (keyName || keyFunc)">
                    <div style="overflow: auto;max-height: 300px;">
                        <button type="button" v-for="uni in options" :class="{'btn btn-sm btn-block': true, 'btn-success': selected.indexOf(uni) >= 0}" @click="toggle(uni, $event)" style="text-align: left"><span v-if="selected.indexOf(uni) >= 0" class="fas fa-check glyphicon glyphicon-ok"></span><span v-else> &nbsp; </span> <span v-if="keyFunc" v-html="uni"></span><span v-else>${ uni }</span></button>
                    </div>
                </div>
            </div>
            <a v-if="selected.length" href="#" class="pl-3" @click="reset"><span class="fas fa-times glyphicon glyphicon-remove text-danger"></span></a>
        </div>
        <div v-else><slot></slot></div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
  delimiters: ['${', '}'],
  props: {
    // list: Array,
    keyFunc: String,
    keyName: String
  },
  data: function () {
    return {
      selected: []
    }
  },
  methods: {
    toggle: function (itm, ev) {
      var self = this
      var idx = self.selected.indexOf(itm)
      if (idx >= 0) {
        self.selected.splice(idx, 1)
      } else {
        self.selected.push(itm)
      }
      self.$emit('filtered', self)
      ev.target.parentNode.parentNode.scrollTo(0, 0)
      self.$nextTick(function () {
        self.$parent.$forceUpdate()
      })
    },
    reset: function () {
      var self = this
      self.selected = []
      self.$emit('filtered', self)
    },
    compar: function (a, b) {
      var self = this
      if (self.selected.indexOf(a) >= 0) {
        return -1
      } else {
        if (self.selected.indexOf(b) >= 0) {
          return 1
        } else {
          if (a > b) {
            return 1
          } else {
            if (a < b) {
              return -1
            } else {
              return 0
            }
          }
        }
      }
    }
  },
  computed: {
    dataset: function () {
      var self = this
      var sheet = self.$parent
      return self.keyFunc || sheet.colNames.indexOf(self.keyName) >= 0 ? sheet.sortedDataset : sheet.sortedRelatedDataset
    },
    options: function () {
      var self = this
      var sheet = self.$parent
      var opts, func
      if (self.keyName) {
        opts = _.uniq(_.map(self.dataset, function (d) { return d[self.keyName] }))
      } else {
        func = sheet.$parent[self.keyFunc]
        opts = _.uniq(_.map(self.dataset, function (d) { return func(d) })) // sheet.invoke(self.keyFunc, d, 'lookup') }))
      }
      // opts = _.filter(opts, function (o) { return o })
      return opts.sort(self.compar)
    }
  }
}
</script>


// WEBPACK FOOTER //
// SheetFunnel.vue?0b8cdefc